import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardContent, Grid, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { SearchGroupsDocument } from 'api';
import { useCurrentUser } from 'hooks';
import { isAdminUser } from 'helpers';
import { GroupCreate } from 'Links';
import { Queries } from 'components';

interface IProps extends WithStyles<typeof styles> {}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      textAlign: 'center',
    },
    image: {
      width: 150,
      height: 150,
    },
  });

const CreateGroup: FC<IProps> = ({ classes }) => {
  const { t } = useTranslation();
  const currentUser = useCurrentUser();

  const { department_id, department_title } = currentUser;
  const isAdmin = isAdminUser(currentUser);
  const isMissingDepartment = !department_id;

  if (isAdmin || isMissingDepartment) {
    return null;
  }

  const variables = {
    required_department_id: department_id,
    size: 0,
    results_from: 0,
  };

  function renderCard() {
    return (
      <Grid item xs>
        <Card className={classes.root}>
          <img src="/images/box-cards.svg" className={classes.image} />
          <CardContent>
            <Typography paragraph align="center" variant="subtitle2">
              {t('components:createGroupWidget', { title: department_title })}
            </Typography>
            <Button component={GroupCreate} variant="contained" color="secondary">
              {t('groups:createGroup')}
            </Button>
          </CardContent>
        </Card>
      </Grid>
    );
  }

  return (
    <Queries.Search
      loader="none"
      fetchPolicy="network-only"
      document={SearchGroupsDocument}
      variables={variables}>
      {({ count }) => (count ? null : renderCard())}
    </Queries.Search>
  );
};

export default withStyles(styles)(CreateGroup);
